export default __webpack_public_path__ + "static/media/ForgotPassword.4bfc2402.less";